import CandidatesPageLayout from '../components/CandidatesPageLayout';
import { ActionDialogContext } from '../components/dialogs/Context/ActionDialogContext';
import useActionDialogContextValue from '../components/dialogs/Context/ActionDialogContextValue';
import CandidateOverviewDialogs from './Components/CandidateOverviewDialogs';
import CandidatesOverviewHeader from './Components/CandidatesOverviewHeader';
import CandidatesOverviewList from './Components/CandidatesOverviewList';
import CandidatesOverviewPageNavigationSidebar from './Components/CandidatesOverviewPageNavigationSidebar';
import { CandidatesOverviewContext } from './Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import useCandidatesOverviewContextValue from './Contexts/CandidatesOverviewContext/UseCandidatesOverviewContextValue';
import { CandidatesTableContext, useCandidatesTable } from './Contexts/CandidatesTableContext/CandidatesTableContext';
import { useRecruitmentId } from '@/Hooks';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';

const CandidatesOverviewPage = () => {
    const recruitmentId = useRecruitmentId();
    const contextValue = useCandidatesOverviewContextValue(recruitmentId);
    const dialogContextValue = useActionDialogContextValue();
    const candidatesTable = useCandidatesTable(contextValue);

    return (
        <ActionDialogContext.Provider value={dialogContextValue}>
            <CandidatesOverviewContext.Provider value={contextValue}>
                <CandidatesTableContext.Provider value={candidatesTable}>
                    <CandidatesPageLayout sidebar={<CandidatesOverviewPageNavigationSidebar />}>
                        <CandidatesOverviewHeader />
                        <CandidatesOverviewList />
                        <CandidateOverviewDialogs />
                    </CandidatesPageLayout>
                </CandidatesTableContext.Provider>
            </CandidatesOverviewContext.Provider>
        </ActionDialogContext.Provider>
    );
};

export default withCompanyProfileRequired(withTalentMeshUserRequired(withSignupChecks(CandidatesOverviewPage)));
